export default [{
    text: 'за все за месяц',
    value: 'allMonthly',
}, {
    text: 'за кв.м. в месяц',
    value: 'squareMeterMonthly',
}, {
    text: 'за кв.м. в год',
    value: 'squareMeterAnnual',
}];
